import { useState, useEffect } from 'react';
import { addBreadcrumb } from '@/utils/sentry';

interface OnlineStatus {
  isOnline: boolean;
  lastChange: number | null;
}

export const useOnlineStatus = (): OnlineStatus => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [lastChange, setLastChange] = useState<number | null>(null);

  useEffect(() => {
    const handleOnline = () => {
      const now = Date.now();
      setIsOnline(true);
      setLastChange(now);
      
      console.info('Connection restored');
      addBreadcrumb('connection-status', 'Connection restored', {
        timestamp: now,
        wasOffline: !navigator.onLine,
      });
    };

    const handleOffline = () => {
      const now = Date.now();
      setIsOnline(false);
      setLastChange(now);
      
      console.warn('Connection lost');
      addBreadcrumb('connection-status', 'Connection lost', {
        timestamp: now,
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return { isOnline, lastChange };
};
